<template>
  <div class="dashboard-header row">
    <!-- Filter input -->
    <div class="col-12 col-lg-6">
      <sleek-filter-input v-model="internalSearchQuery" placeholder="Filter by name..." />
    </div>
    <!-- Grid/list toggle on desktop only -->
    <div v-if="$screen.isDesktop($mq)" class="col-12 col-lg-6">
      <dashboard-grid-list-toggle v-model:view-type="internalViewType" />
    </div>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */
import DashboardGridListToggle from '@/screens/dashboard/components/dashboard-grid-list-toggle.vue'
import SleekFilterInput from '@/components/global/inputs/sleek-filter-input.vue'

/* Helpers */

/* Data types */

/* API */

export default defineComponent({
  name: 'DashboardHeader',
  components: {
    DashboardGridListToggle,
    SleekFilterInput,
  },
  props: {
    viewType: {
      type: String,
      required: true,
    },
    searchQuery: {
      type: String,
      required: true,
    },
  },
  emits: ['update-view-type', 'update:searchQuery'],
  computed: {
    internalViewType: {
      get(): any {
        return this.viewType
      },
      set(newValue: any) {
        this.$emit('update-view-type', newValue)
      },
    },
    internalSearchQuery: {
      get(): any {
        return this.searchQuery
      },
      set(newValue: any) {
        this.$emit('update:searchQuery', newValue)
      },
    },
  },
})
</script>

<style lang="scss">
.dashboard-header {
  margin: 0 15px 24px 15px;

  @include media-breakpoint-up(lg) {
    margin-bottom: 6px;
  }

  .dashboard-grid-list-toggle {
    margin: 30px 0 20px 0;

    @include media-breakpoint-up(lg) {
      margin: 0 0 20px 0;
      margin-left: auto;
    }
  }
}
</style>
